import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function BlogCard({ post }) {
  const navigate = useNavigate();

  return (
    <motion.div
      whileHover={{
        y: -8
      }}
      className="blog-card-premium"
      onClick={() =>
        navigate(`/blog/${post.slug}`)
      }
    >
      <div className="blog-category">
        {post.category}
      </div>

      <h3>
        {post.title}
      </h3>

      <p>
        {post.excerpt}
      </p>

      <div className="blog-footer">
        <span>
          {post.readTime}
        </span>

        <span>
          Read Article →
        </span>
      </div>
    </motion.div>
  );
}

export default BlogCard;